import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import GlobalTheme from '@atlaskit/theme/components';
import { Theme } from '../theme';
import { name as packageName, version as packageVersion } from '../version.json';
import Input from './Input';

var Textfield = /*#__PURE__*/function (_React$Component) {
  _inherits(Textfield, _React$Component);

  var _super = _createSuper(Textfield);

  function Textfield() {
    var _this;

    _classCallCheck(this, Textfield);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false,
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "input", null);

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (event) {
      _this.setState({
        isFocused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (event) {
      _this.setState({
        isFocused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseDown", function (event) {
      /** Running e.preventDefault() on the INPUT prevents double click behaviour */
      // Sadly we needed this cast as the target type is being correctly set
      var target = event.target;

      if (target.tagName !== 'INPUT') {
        event.preventDefault();
      }

      if (_this.input && !_this.props.isDisabled && document.activeElement !== _this.input) {
        _this.input.focus();
      }

      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      if (!_this.props.isDisabled) {
        _this.setState({
          isHovered: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      if (!_this.props.isDisabled) {
        _this.setState({
          isHovered: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (input) {
      _this.input = input;
      var forwardedRef = _this.props.forwardedRef;

      if (!forwardedRef) {
        return;
      }

      if (_typeof(forwardedRef) === 'object') {
        // This is a blunder on the part of @types/react
        // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
        // .current should be assignable
        // @ts-ignore
        forwardedRef.current = input;
      }

      if (typeof forwardedRef === 'function') {
        forwardedRef(input);
      }
    });

    return _this;
  }

  _createClass(Textfield, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isFocused = _this$state.isFocused,
          isHovered = _this$state.isHovered;

      var _this$props = this.props,
          createAnalyticsEvent = _this$props.createAnalyticsEvent,
          forwardedRef = _this$props.forwardedRef,
          appearance = _this$props.appearance,
          isCompact = _this$props.isCompact,
          isDisabled = _this$props.isDisabled,
          isInvalid = _this$props.isInvalid,
          isRequired = _this$props.isRequired,
          isReadOnly = _this$props.isReadOnly,
          isMonospaced = _this$props.isMonospaced,
          theme = _this$props.theme,
          width = _this$props.width,
          elemAfterInput = _this$props.elemAfterInput,
          elemBeforeInput = _this$props.elemBeforeInput,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["createAnalyticsEvent", "forwardedRef", "appearance", "isCompact", "isDisabled", "isInvalid", "isRequired", "isReadOnly", "isMonospaced", "theme", "width", "elemAfterInput", "elemBeforeInput", "testId"]);

      return /*#__PURE__*/React.createElement(Theme.Provider, {
        value: theme
      }, /*#__PURE__*/React.createElement(GlobalTheme.Consumer, null, function (_ref) {
        var mode = _ref.mode;
        return /*#__PURE__*/React.createElement(Theme.Consumer, {
          appearance: appearance,
          mode: mode,
          width: width,
          isDisabled: isDisabled,
          isCompact: isCompact,
          isMonospaced: isMonospaced,
          isFocused: isFocused,
          isHovered: isHovered,
          isInvalid: isInvalid
        }, function (tokens) {
          return /*#__PURE__*/React.createElement(Input
          /* spreading before applying other props to prevent overwriting */
          , _extends({}, otherProps, {
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired,
            theme: tokens,
            onBlur: _this2.handleOnBlur,
            onFocus: _this2.handleOnFocus,
            onMouseEnter: _this2.onMouseEnter,
            onMouseLeave: _this2.onMouseLeave,
            onMouseDown: _this2.handleOnMouseDown,
            elemAfterInput: elemAfterInput,
            elemBeforeInput: elemBeforeInput,
            innerRef: _this2.setInputRef,
            testId: testId
          }));
        });
      }));
    }
  }]);

  return Textfield;
}(React.Component);

_defineProperty(Textfield, "defaultProps", {
  appearance: 'standard',
  isCompact: false,
  isMonospaced: false,
  isInvalid: false,
  isRequired: false,
  isReadOnly: false,
  isDisabled: false
});

var ForwardRefTextfield = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Textfield, _extends({}, props, {
    forwardedRef: ref
  }));
});
export { ForwardRefTextfield as TextFieldWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export default withAnalyticsContext({
  componentName: 'textField',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onBlur: createAndFireEventOnAtlaskit({
    action: 'blurred',
    actionSubject: 'textField',
    attributes: {
      componentName: 'textField',
      packageName: packageName,
      packageVersion: packageVersion
    }
  }),
  onFocus: createAndFireEventOnAtlaskit({
    action: 'focused',
    actionSubject: 'textField',
    attributes: {
      componentName: 'textField',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(ForwardRefTextfield));